export const extractDataFromJwt = token => {
  if ( !token || !token.split ) {
    throw 'Invalid token';
  }
  const parts = token.split( '.' );
  if ( parts.length !== 3 ) {
    throw 'Invalid token';
  }
  // [WindowOrWorkerGlobalScope.atob()](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/atob)
  return JSON.parse( atob( parts[1] ) );
};

export const UserIdentity = Object.freeze( {
  get token() {
    return sessionStorage.getItem( 'hash' );
  },
  set token( value ) {
    if ( !value ) {
      return sessionStorage.removeItem( 'hash' );
    }
    return sessionStorage.setItem( 'hash', value );
  },
  get jwt() {
    return sessionStorage.getItem( 'token' );
  },
  set jwt( jsonToken ) {
    if ( !jsonToken ) {
      return sessionStorage.removeItem( 'token' );
    }
    return sessionStorage.setItem( 'token', jsonToken );
  }
} );